import { render, staticRenderFns } from "./main-section.vue?vue&type=template&id=5dd5a9c9&scoped=true"
import script from "./main-section.vue?vue&type=script&lang=js"
export * from "./main-section.vue?vue&type=script&lang=js"
import style0 from "./main-section.vue?vue&type=style&index=0&id=5dd5a9c9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5dd5a9c9",
  null
  
)

export default component.exports